import type { Entry } from "../types";

export const educateSageMessages = {
  navEducateSage: { ko: "세이지 가르치기", en: "Educate Sage" },
  educateSageTabLessons: { ko: "사례", en: "Lessons" },
  educateSageTabTestHistory: { ko: "검증 기록", en: "Test history" },
  testHistoryEmpty: { ko: "아직 실행한 검증이 없습니다.", en: "No lesson tests run yet." },
  testHistoryOngoing: { ko: "진행 중", en: "Ongoing" },
  testHistoryDone: { ko: "완료", en: "Done" },
  backToLesson: { ko: "사례로 돌아가기", en: "Back to lesson" },
  educateSageIntro: {
    ko: "실제로 검토했던 사례(원본 자료, 피드백, 수정된 자료)를 등록하면 AI가 규칙을 초안으로 작성합니다. 저장 전에 내용을 확인하고 수정할 수 있습니다.",
    en: "Add a real case — the material you were asked to check, your feedback, and the corrected material — and the AI drafts a rule from it. You review and edit it before it's saved.",
  },
  newLesson: { ko: "새 사례 등록", en: "New case" },
  lessonListEmpty: {
    ko: "아직 등록된 사례가 없습니다. 처음 처리했던 실제 사례로 시작해보세요.",
    en: "No lessons yet. Start with a real case you've already handled.",
  },
  lessonStepOriginal: { ko: "원본 자료", en: "Original material" },
  lessonStepFeedback: { ko: "피드백 및 수정본", en: "Feedback & correction" },
  lessonStepReview: { ko: "AI 초안 확인", en: "Review AI draft" },
  lessonOriginalHelp: {
    ko: "마케팅팀이 검토를 요청했던 원본 자료를 업로드하거나 내용을 입력하세요.",
    en: "Upload or paste the material the marketing team originally asked you to check.",
  },
  lessonOriginalDropzone: { ko: "원본 자료 업로드", en: "Upload the original material" },
  lessonOriginalTextLabel: { ko: "또는 텍스트로 입력", en: "Or paste the text instead" },
  lessonFeedbackHelp: {
    ko: "그때 남긴 피드백을 입력하거나, 피드백 문서를 업로드하면 자동으로 내용을 추출합니다.",
    en: "Type the feedback you gave, or upload the feedback document and its text will be extracted automatically.",
  },
  lessonFeedbackDropzone: { ko: "피드백 문서 업로드 (.docx, .pdf)", en: "Upload the feedback document (.docx, .pdf)" },
  lessonFeedbackTextLabel: { ko: "피드백 내용", en: "Feedback comments" },
  lessonFeedbackTextPlaceholder: {
    ko: "예: 2.3 조건부사유 — 상품이미지광고의 경우에도 필수안내사항을 기재해야 합니다.",
    en: "For example: clause 2.3 — product-image ads also require the standard disclosure items.",
  },
  lessonModifiedHelp: {
    ko: "피드백을 반영해 수정된 최종 자료를 업로드하거나 내용을 입력하세요.",
    en: "Upload or paste the material after the feedback was applied.",
  },
  lessonModifiedDropzone: { ko: "수정된 자료 업로드", en: "Upload the corrected material" },
  lessonModifiedTextLabel: { ko: "또는 텍스트로 입력", en: "Or paste the text instead" },
  lessonGenerate: { ko: "AI로 초안 만들기", en: "Draft with AI" },
  lessonGenerating: { ko: "AI가 사례를 분석하는 중입니다…", en: "AI is analyzing the case…" },
  lessonDraftStageUpload: { ko: "자료 업로드 중", en: "Uploading materials" },
  lessonDraftStageExtract: { ko: "원본 및 피드백 내용 추출 중", en: "Reading original & feedback" },
  lessonDraftStageAnalyze: { ko: "컴플라이언스 격차 분석 중", en: "Analyzing the compliance gap" },
  lessonDraftStageDraft: { ko: "규칙 초안 작성 중", en: "Drafting the rule" },
  lessonDraftElapsed: { ko: "{seconds}초 경과", en: "{seconds}s elapsed" },
  lessonDraftProgressBadge: { ko: "세이지 가르치기", en: "Educate Sage" },
  lessonDraftToastReady: {
    ko: "사례 초안이 준비되었습니다. 저장 전에 확인해 주세요.",
    en: "The lesson draft is ready. Review it before saving.",
  },
  lessonDraftToastFailed: {
    ko: "사례 초안을 만들지 못했습니다.",
    en: "Could not draft the lesson.",
  },
  lessonDraftToastView: { ko: "확인하기", en: "Review" },
  lessonDraftReady: {
    ko: "초안 준비됨 — 저장 전에 확인하세요",
    en: "Draft ready — review before saving",
  },
  lessonDraftFailed: { ko: "초안 작성에 실패했습니다.", en: "Drafting failed." },
  lessonDraftContinue: { ko: "이어서 하기", en: "Continue" },
  lessonDraftInProgressHint: {
    ko: "AI가 사례를 분석하는 중입니다. 다른 페이지로 이동해도 계속 진행됩니다.",
    en: "AI is analyzing the case. You can leave this page — drafting continues.",
  },
  lessonDraftReadyHint: {
    ko: "초안이 준비되었습니다. 내용을 확인하고 저장하세요.",
    en: "The draft is ready. Review the fields and save the lesson.",
  },
  lessonDraftBanner: {
    ko: "AI가 이 사례를 바탕으로 아래 내용을 제안했습니다. 저장하기 전에 확인하고 필요하면 수정하세요.",
    en: "AI proposed the fields below from this case. Review and edit them before saving.",
  },
  lessonSummaryLabel: { ko: "한 줄 요약 (사용자에게 표시됨)", en: "Plain-language summary (shown to users)" },
  lessonApplied: { ko: "적용 중", en: "Applied" },
  lessonNotApplied: { ko: "미적용 (초안)", en: "Not applied (draft)" },
  lessonInactive: { ko: "비활성", en: "Inactive" },
  lessonDeactivate: { ko: "비활성화", en: "Deactivate" },
  lessonReactivate: { ko: "다시 적용", en: "Reactivate" },
  deactivateLessonConfirm: {
    ko: "‘{title}’ 사례를 비활성화하시겠습니까? Sage에게 묻기와 광고 검토에 더 이상 적용되지 않습니다.",
    en: "Deactivate the lesson “{title}”? Ask Sage and reviews will stop using it.",
  },
  lessonDraftsNotApplied: {
    ko: "아직 적용되지 않은 사례가 {count}건 있습니다. 초안 상태의 사례는 Sage에게 묻기와 광고 검토에 사용되지 않습니다.",
    en: "{count} lessons are not applied yet. Draft lessons are not used by Ask Sage or reviews.",
  },
  lessonApplyAll: { ko: "모두 적용", en: "Apply all" },
  lessonApplyAllConfirm: {
    ko: "초안 상태의 사례 {count}건을 모두 적용하시겠습니까? 적용 즉시 Sage에게 묻기와 광고 검토에 반영됩니다.",
    en: "Apply all {count} draft lessons? They take effect in Ask Sage and reviews immediately.",
  },
  lessonApplyAllDone: { ko: "사례 {count}건을 적용했습니다.", en: "Applied {count} lessons." },
  lessonApplyAllPartial: {
    ko: "사례 {count}건을 적용했습니다. 다음 사례는 적용하지 못했습니다(상세 화면에서 확인하세요): {skipped}",
    en: "Applied {count} lessons. These could not be applied (open each to check): {skipped}",
  },
  lessonSearchPlaceholder: { ko: "사례 제목, 내용 검색", en: "Search lessons by title or content" },
  lessonSaveDraftButton: { ko: "초안으로 저장", en: "Save as draft" },
  lessonSaveAndApplyButton: { ko: "저장 후 바로 적용", en: "Save and apply now" },
  lessonAppliedNow: {
    ko: "저장 후 바로 적용했습니다. Sage에게 묻기와 광고 검토에 즉시 반영됩니다.",
    en: "Saved and applied. Ask Sage and reviews use it from now on.",
  },
  lessonSourceCase: { ko: "원본 사례", en: "Source case" },
  lessonSourceOriginal: { ko: "원본 자료", en: "Original material" },
  lessonSourceFeedback: { ko: "담당자 피드백", en: "Compliance feedback" },
  lessonSourceModified: { ko: "수정된 자료", en: "Corrected material" },
  lessonTryIt: { ko: "직접 검증해보기", en: "Try it" },
  lessonTryItHelp: {
    ko: "이 사례로 만들어진 규칙이 실제로 유사한 자료를 잡아내는지 자료를 업로드해 확인해보세요.",
    en: "Upload a material to see whether the rule this lesson created actually catches a similar issue.",
  },
  lessonTryItRun: { ko: "검증 실행", en: "Run test" },
  lessonTryItRunning: { ko: "AI 컴플라이언스 검토를 실행하는 중입니다…", en: "Running the AI compliance check…" },
  lessonNotActive: {
    ko: "이 사례를 검증하려면 먼저 규칙을 활성화하세요.",
    en: "Activate this lesson's rule before testing it.",
  },
  lessonTestResultBanner: {
    ko: "이것은 Educate Sage 사례 검증 결과입니다. 실제 검토 요청이 아니며, 이 화면은 오직 AI가 이 규칙을 얼마나 잘 잡아내는지 보여주기 위한 것입니다.",
    en: "This is an Educate Sage lesson test result, not a real review request — it exists only to show how well the AI catches this specific rule.",
  },
  lessonTestScopeOnlyThis: { ko: "이 사례만 검증", en: "Only this lesson" },
  lessonTestScopeWithOthers: { ko: "다른 규칙과 함께 검증", en: "Include other rules" },
  lessonTestScopeWithOthersHelp: {
    ko: "함께 검증할 규칙을 선택하세요. 이 사례의 규칙은 항상 포함됩니다.",
    en: "Choose which rules to combine with this test. This lesson's rule is always included.",
  },
  lessonTestScopeEmpty: {
    ko: "선택할 수 있는 다른 활성 규칙이 없습니다.",
    en: "No other active rules are available to combine.",
  },
  deleteLessonConfirm: {
    ko: "‘{title}’ 사례를 삭제하시겠습니까? 모든 버전과 원본 사례 자료가 영구적으로 삭제됩니다. 이 작업은 되돌릴 수 없습니다.",
    en: "Delete the lesson “{title}”? All versions and the source case will be permanently deleted. This action cannot be undone.",
  },
} as const satisfies Record<string, Entry>;
